import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconPortal(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M6 8a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H6ZM5 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM6 14a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H6Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 4H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h3v2h12v-2h3c1.1 0 1.99-.9 1.99-2L23 6a2 2 0 0 0-2-2ZM3 18V6h18v12H3Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
